<script>
    export let value;
</script>
    
<input type="button" value={value} disabled />